import { useState, useEffect } from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import { useNavigate, useLocation } from "react-router-dom";
// import "./SystemAuditCapitalMarket.css";

export default function SystemAuditCapitalMarket() {
  const navigate = useNavigate();
  const location = useLocation();
  const [activeTab, setActiveTab] = useState("");

  useEffect(() => {
    const currentPath = location.pathname;
    if (currentPath === "/depository-participant-audit") setActiveTab("dp");
    else if (currentPath === "/system-audit-capital-market")
      setActiveTab("system");
    else if (currentPath === "/exchange-sebi-compliances")
      setActiveTab("exchange");
    else if (currentPath === "/ipo-listing-support") setActiveTab("ipo");
    else if (currentPath === "/capital-market-sebi") setActiveTab("capital");
  }, [location.pathname]);

  const handleTabClick = (tab, path) => {
    setActiveTab(tab);
    navigate(path);
  };

  return (
    <>
      <Header />

      {/* ===== HERO SECTION (class names unchanged) ===== */}
      <section
        className="about-hero"
        style={{
          backgroundImage: "url('/assets/img/Achievements.jpg')",
        }}
      >
        <div className="overlay"></div>
        <div className="about-hero-text">
          <h1>System Audit for Capital Market Intermediaries</h1>
          <p>
            Ensuring compliance, IT security, and operational integrity for
            capital market entities under SEBI and exchange regulations.
          </p>
        </div>
      </section>

      {/* ===== SAME TAB STRUCTURE (unchanged classes) ===== */}
      <div className="tax-tabs">
        <button
          className={activeTab === "capital" ? "active" : ""}
          onClick={() => handleTabClick("capital", "/capital-market-sebi")}
        >
          Capital Market & SEBI Advisory
        </button>

        <button
          className={activeTab === "dp" ? "active" : ""}
          onClick={() => handleTabClick("dp", "/depository-participant-audit")}
        >
          Depository Participant (DP) Audit – NSDL/CDSL
        </button>

        <button
          className={activeTab === "system" ? "active" : ""}
          onClick={() =>
            handleTabClick("system", "/system-audit-capital-market")
          }
        >
          System Audit for Capital Market Intermediaries
        </button>

        <button
          className={activeTab === "exchange" ? "active" : ""}
          onClick={() =>
            handleTabClick("exchange", "/exchange-sebi-compliances")
          }
        >
          Exchange & SEBI Compliances
        </button>

        <button
          className={activeTab === "ipo" ? "active" : ""}
          onClick={() => handleTabClick("ipo", "/ipo-listing-support")}
        >
          IPO & Listing Support
        </button>
      </div>

      {/* ===== SERVICE CONTENT (BOOTSTRAP GRID + CARDS) ===== */}
      <section className="service-content container py-2">
        <div className="row mb-4">
          <div className="col-12">
            {/* <div className="svc-intro card-border"> */}
            <h2 className="section-title mb-4">
              System Audit for Capital Market Intermediaries
            </h2>

            <p className="service-text">
              Capital market intermediaries heavily depend on technology —
              trading systems, OMS/RMS, back-office software, APIs & algo
              engines. SEBI mandates System Audits to ensure intermediaries
              operate secure, stable, and compliant technology environments.
            </p>
            <p className="service-text mt-3">
              At <strong>S D P M & Co.</strong>, we provide comprehensive System
              Audits for Stock Brokers, Trading Members, Depository
              Participants, RIAs, Research Analysts, PMS Managers, Algo Traders
              & FinTech Platforms.
            </p>
          </div>
        </div>
        {/* </div> */}

        <h3 className="dp-section-title mt-4">System Audit Scope</h3>

        <div className="row g-4">
          {/* Card: IT & Cyber Security Audit */}
          <div className="col-md-6">
            <div className="dp-card">
              <h4>1. IT & Cyber Security Audit (as per SEBI Framework)</h4>
              <p>We evaluate:</p>
              <ul>
                <li>Network architecture</li>
                <li>Firewall configurations</li>
                <li>Antivirus & malware protection</li>
                <li>Log monitoring & backups</li>
                <li>Data encryption</li>
                <li>Patch management</li>
              </ul>
              <p className="small-note">
                Our checks align with SEBI cybersecurity circulars.
              </p>
            </div>
          </div>

          {/* Card: Trading System & Application Controls */}
          <div className="col-md-6">
            <div className="dp-card">
              <h4>2. Trading System & Application Controls Review</h4>
              <p>We assess:</p>
              <ul>
                <li>OMS/RMS functionality</li>
                <li>Trading application stability</li>
                <li>Order routing & validation</li>
                <li>Error handling & audit trail</li>
                <li>API integrations</li>
              </ul>
              <p className="small-note">
                This ensures safe and compliant trade execution.
              </p>
            </div>
          </div>

          {/* Card: Algo Trading System Audit */}
          <div className="col-md-6">
            <div className="dp-card">
              <h4>3. Algo Trading System Audit</h4>
              <p>For algo users, we review:</p>
              <ul>
                <li>Algo approvals & registration</li>
                <li>Strategy documentation</li>
                <li>Backtesting & deployment logs</li>
                <li>Risk controls (throttle, price band, limits)</li>
                <li>Kill-switch mechanisms</li>
              </ul>
              <p className="small-note">
                Ensures compliance with SEBI Algo Trading Guidelines.
              </p>
            </div>
          </div>

          {/* Card: User Access, Rights & Maker-Checker */}
          <div className="col-md-6">
            <div className="dp-card">
              <h4>4. User Access, Rights & Maker-Checker Controls</h4>
              <p>We evaluate:</p>
              <ul>
                <li>Segregation of duties</li>
                <li>Role-based access</li>
                <li>Password policy compliance</li>
                <li>Approval workflows</li>
                <li>Maker-checker mechanisms</li>
              </ul>
            </div>
          </div>

          {/* Card: Data Backup, DR & BCP Audit */}
          <div className="col-md-6">
            <div className="dp-card">
              <h4>5. Data Backup, DR & BCP Audit</h4>
              <p>We audit:</p>
              <ul>
                <li>Backup frequency & retention</li>
                <li>DR site readiness</li>
                <li>Power/UPS controls</li>
                <li>BCP drill documentation</li>
                <li>RTO/RPO standards compliance</li>
              </ul>
            </div>
          </div>

          {/* Card: VAPT Support */}
          <div className="col-md-6">
            <div className="dp-card">
              <h4>6. VAPT (Vulnerability & Penetration Testing) Support</h4>
              <p>We coordinate VAPT activities to identify:</p>
              <ul>
                <li>Cyber vulnerabilities</li>
                <li>Network gaps</li>
                <li>Potential attack surfaces</li>
                <li>Remediation suggestions post-testing</li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* Full width: Benefits & Deliverables */}
      {/* <div className="col-12">
        <div className="nri-highlight">
          <h3 className="mb-3"> Why Choose Us?</h3>
          <ul>
            <li>SEBI-aligned audit methodology</li>
            <li>Deep understanding of capital market technology</li>
            <li>Practical recommendations, not generic reports</li>
            <li>Smooth coordination during exchange inspections</li>
            <li>Complete confidentiality</li>
          </ul>
        </div>
      </div> */}

      {/* CTA box */}
      {/* <div
        style={{
          width: "100%",
          background: "#00385f",
          padding: "70px 20px",
        }}
      >
        <div
          style={{
            maxWidth: "900px",
            margin: "0 auto",
            textAlign: "center",
          }}
        >
          <h3
            style={{
              fontSize: "28px",
              fontWeight: "700",
              color: "#ffffff",
            }}
          >
            Looking to ensure SEBI compliance and robust IT governance?
          </h3>

          <p
            style={{
              fontSize: "16px",
              color: "#e3e3e3",
              margin: "15px 0 30px",
              lineHeight: "1.7",
            }}
          >
            Connect with our experienced system audit professionals today and
            strengthen your organization’s IT infrastructure.
          </p>

          <Link
            to="/contactus"
            className="btn px-4 py-2 fw-semibold"
            style={{
              backgroundColor: "#65ad4b",
              color: "#fff",
              borderRadius: "8px",
              padding: "12px 28px",
              fontSize: "16px",
              fontWeight: "600",
              textDecoration: "none",
            }}
            onClick={() =>
              window.scrollTo({
                top: 0,
                behavior: "smooth",
              })
            }
          >
            Contact Us
          </Link>
        </div>
      </div> */}

      <Footer />
    </>
  );
}
